import React from 'react';

/**
 * The Qern "Q" mark (ring + tail + 4-point spark on a slate tile), as on
 * qern.net and in public/favicon.svg. Decorative: the wordmark next to it
 * carries the name.
 */
export const QMark: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <rect width="64" height="64" rx="14" fill="#0f172a" />
    <circle cx="29" cy="28" r="17" fill="none" stroke="#38bdf8" strokeWidth="4.5" strokeLinecap="round" />
    <line x1="35" y1="34" x2="45" y2="44" stroke="#38bdf8" strokeWidth="4.5" strokeLinecap="round" />
    <line x1="42.5" y1="41.5" x2="47.5" y2="46.5" stroke="#38bdf8" strokeWidth="4.5" strokeLinecap="round" />
    <line x1="47.5" y1="41.5" x2="42.5" y2="46.5" stroke="#38bdf8" strokeWidth="4.5" strokeLinecap="round" />
  </svg>
);
